export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/advantage-integrated.30265302-384b8a.svg";